import { render, staticRenderFns } from "./ImageSizeSetter.vue?vue&type=template&id=92be47b0&scoped=true&"
import script from "./ImageSizeSetter.vue?vue&type=script&lang=js&"
export * from "./ImageSizeSetter.vue?vue&type=script&lang=js&"
import style0 from "./ImageSizeSetter.vue?vue&type=style&index=0&id=92be47b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92be47b0",
  null
  
)

component.options.__file = "ImageSizeSetter.vue"
export default component.exports